
/* The Pawsonality — Segmented Email Capture Popup
   Shows after 8s delay, once per 7 days. Pet type question → discount reveal. */
(function() {
  var COOKIE = 'paw_popup_seen';
  var DELAY = 20000;
  var COOLDOWN_DAYS = 7;

  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? m[2] : null;
  }
  function setCookie(n, v, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 86400000);
    document.cookie = n + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  if (getCookie(COOKIE)) return;

  function createPopup() {
    var overlay = document.createElement('div');
    overlay.id = 'paw-popup-overlay';
    overlay.innerHTML = [
      '<div id="paw-popup-overlay-bg" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9998;opacity:0;transition:opacity 0.3s;"></div>',
      '<div id="paw-popup-box" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) scale(0.9);z-index:9999;background:#fff;border-radius:20px;max-width:400px;width:90%;padding:32px 28px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,0.3);opacity:0;transition:all 0.3s ease;">',
      '  <button id="paw-popup-close" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:20px;color:#9ca3af;cursor:pointer;padding:4px;">&times;</button>',
      '  <div id="paw-popup-step1">',
      '    <div style="font-size:48px;margin-bottom:12px;">&#128062;</div>',
      '    <h3 style="font-size:22px;font-weight:800;color:#78350f;margin:0 0 8px;">What kind of pet parent are you?</h3>',
      '    <p style="font-size:14px;color:#92400e;margin:0 0 20px;">Tell us and unlock an exclusive discount!</p>',
      '    <div style="display:flex;gap:10px;justify-content:center;">',
      '      <button class="paw-pet-btn" data-pet="dog" style="flex:1;padding:14px;border-radius:12px;border:2px solid #fde68a;background:#fffbeb;cursor:pointer;transition:all 0.2s;font-size:14px;font-weight:600;color:#78350f;">&#128054; Dog</button>',
      '      <button class="paw-pet-btn" data-pet="cat" style="flex:1;padding:14px;border-radius:12px;border:2px solid #fde68a;background:#fffbeb;cursor:pointer;transition:all 0.2s;font-size:14px;font-weight:600;color:#78350f;">&#128049; Cat</button>',
      '      <button class="paw-pet-btn" data-pet="other" style="flex:1;padding:14px;border-radius:12px;border:2px solid #fde68a;background:#fffbeb;cursor:pointer;transition:all 0.2s;font-size:14px;font-weight:600;color:#78350f;">&#128060; Other</button>',
      '    </div>',
      '  </div>',
      '  <div id="paw-popup-step2" style="display:none;">',
      '    <div style="font-size:48px;margin-bottom:8px;">&#127881;</div>',
      '    <h3 style="font-size:22px;font-weight:800;color:#78350f;margin:0 0 4px;">15% Off Your First Portrait!</h3>',
      '    <p id="paw-popup-personalized" style="font-size:14px;color:#92400e;margin:0 0:16px;"></p>',
      '    <div style="margin:16px 0;">',
      '      <div style="display:inline-block;padding:10px 24px;background:#fef3c7;border:2px dashed #f59e0b;border-radius:10px;font-size:20px;font-weight:800;letter-spacing:2px;color:#b45309;">PAWFIRST15</div>',
      '    </div>',
      '    <input id="paw-popup-email" type="email" placeholder="Enter your email" style="width:100%;padding:12px 16px;border:2px solid #fde68a;border-radius:10px;font-size:14px;outline:none;margin-bottom:12px;box-sizing:border-box;" />',
      '    <button id="paw-popup-submit" style="width:100%;padding:12px;border-radius:10px;background:#b45309;color:#fff;font-weight:700;font-size:15px;border:none;cursor:pointer;transition:background 0.2s;">Claim My 15% Off</button>',
      '    <p style="font-size:11px;color:#9ca3af;margin:10px 0 0;">No spam, just cute pet art. Unsubscribe anytime.</p>',
      '  </div>',
      '  <div id="paw-popup-step3" style="display:none;">',
      '    <div style="font-size:48px;margin-bottom:12px;">&#10024;</div>',
      '    <h3 style="font-size:22px;font-weight:800;color:#15803d;margin:0 0 8px;">You&apos;re In!</h3>',
      '    <p style="font-size:14px;color:#166534;margin:0 0 16px;">Use code <strong>PAWFIRST15</strong> at checkout for 15% off your first portrait.</p>',
      '    <a href="/collections" style="display:inline-block;padding:12px 28px;background:#b45309;color:#fff;font-weight:700;border-radius:10px;text-decoration:none;font-size:14px;">Browse Styles</a>',
      '  </div>',
      '</div>'
    ].join('\n');

    document.body.appendChild(overlay);

    setTimeout(function() {
      document.getElementById('paw-popup-overlay-bg').style.opacity = '1';
      var box = document.getElementById('paw-popup-box');
      box.style.opacity = '1';
      box.style.transform = 'translate(-50%,-50%) scale(1)';
    }, 50);

    var petMessages = {
      dog: 'Your pup deserves to be immortalized in art!',
      cat: 'Your kitty is about to become a masterpiece!',
      other: 'Every pet deserves the royal treatment!'
    };

    document.querySelectorAll('.paw-pet-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var pet = this.getAttribute('data-pet');
        document.getElementById('paw-popup-personalized').textContent = petMessages[pet] || petMessages.other;
        document.getElementById('paw-popup-step1').style.display = 'none';
        document.getElementById('paw-popup-step2').style.display = 'block';
      });

      btn.addEventListener('mouseenter', function() {
        this.style.borderColor = '#f59e0b';
        this.style.background = '#fef3c7';
        this.style.transform = 'scale(1.05)';
      });
      btn.addEventListener('mouseleave', function() {
        this.style.borderColor = '#fde68a';
        this.style.background = '#fffbeb';
        this.style.transform = 'scale(1)';
      });
    });

    document.getElementById('paw-popup-submit').addEventListener('click', function() {
      var email = document.getElementById('paw-popup-email').value.trim();
      if (!email || email.indexOf('@') < 0) {
        document.getElementById('paw-popup-email').style.borderColor = '#ef4444';
        return;
      }
      this.textContent = 'Subscribing...';
      this.disabled = true;
      setCookie(COOKIE, '1', COOLDOWN_DAYS);
      // TODO: wire to Klaviyo/Mailchimp when ready
      setTimeout(function() {
        document.getElementById('paw-popup-step2').style.display = 'none';
        document.getElementById('paw-popup-step3').style.display = 'block';
      }, 600);
    });

    function closePopup() {
      setCookie(COOKIE, '1', COOLDOWN_DAYS);
      var bg = document.getElementById('paw-popup-overlay-bg');
      var box = document.getElementById('paw-popup-box');
      if (bg) bg.style.opacity = '0';
      if (box) { box.style.opacity = '0'; box.style.transform = 'translate(-50%,-50%) scale(0.9)'; }
      setTimeout(function() { overlay.remove(); }, 300);
    }

    document.getElementById('paw-popup-close').addEventListener('click', closePopup);
    document.getElementById('paw-popup-overlay-bg').addEventListener('click', closePopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(createPopup, DELAY); });
  } else {
    setTimeout(createPopup, DELAY);
  }
})();
